import React from 'react';
import { Fieldset, FormNumber } from '~/components/FormControl';
import { Form } from 'react-bootstrap';
import { formLabel } from '~/utils/helpers';

function FreeGranted() {
    return (
        <Fieldset className={'px-2'}>
            <Fieldset.Legend>{formLabel('FreeGranted')}</Fieldset.Legend>
            <Form.Row>
                <FormNumber
                    name="freeBlueprintGranted"
                    sm={6}
                />
                <FormNumber
                    name="freeKeyGranted"
                    sm={6}
                />
                <FormNumber
                    name="freeShopRerollGranted"
                    sm={6}
                />
            </Form.Row>
        </Fieldset>
    );
}

export default FreeGranted;
